import OErrorClass from "components/organisms/manuscript/adapter/o-error";
import core from "components/organisms/manuscript/overleaf/editor-core/lib";
import ClearTrackingPropsClass from "components/organisms/manuscript/overleaf/editor-core/lib/file_data/clear_tracking_props";

export const AddCommentOperation = core.AddCommentOperation;
export const AddFileOperation = core.AddFileOperation;
export const Author = core.Author;
export const AuthorList = core.AuthorList;
export const Blob = core.Blob;
export const Change = core.Change;
export const ChangeNote = core.ChangeNote;
export const ChangeRequest = core.ChangeRequest;
export const Chunk = core.Chunk;
export const ChunkResponse = core.ChunkResponse;
export const ClearTrackingProps = ClearTrackingPropsClass;
export const Comment = core.Comment;
export const CommentList = core.CommentList;
export const DeleteCommentOperation = core.DeleteCommentOperation;
export const EditFileOperation = core.EditFileOperation;
export const EditNoOperation = core.EditNoOperation;
export const EditOperation = core.EditOperation;
export const EditOperationBuilder = core.EditOperationBuilder;
export const EditOperationTransformer = core.EditOperationTransformer;
export const File = core.File;
export const FileMap = core.FileMap;
export const History = core.History;
export const InsertOp = core.InsertOp;
export const Label = core.Label;
export const LazyStringFileData = core.LazyStringFileData;
export const MoveFileOperation = core.MoveFileOperation;
export const NoOperation = core.NoOperation;
export const Operation = core.Operation;
export const OError = OErrorClass;
export const Origin = core.Origin;
export const OtClient = core.OtClient;
export const Range = core.Range;
export const RemoveOp = core.RemoveOp;
export const RestoreFileOrigin = core.RestoreFileOrigin;
export const RestoreOrigin = core.RestoreOrigin;
export const RetainOp = core.RetainOp;
export const ScanOp = core.ScanOp;
export const SetCommentStateOperation = core.SetCommentStateOperation;
export const SetFileMetadataOperation = core.SetFileMetadataOperation;
export const Snapshot = core.Snapshot;
export const StringFileData = core.StringFileData;
export const TextOperation = core.TextOperation;
export const TrackedChange = core.TrackedChange;
export const TrackedChangeList = core.TrackedChangeList;
export const TrackingProps = core.TrackingProps;
export const V2DocVersions = core.V2DocVersions;
export const getDocUpdaterCompatibleRanges = core.getDocUpdaterCompatibleRanges;
export const safePathname = core.safePathname;
export const util = core.util;

export default core;
